import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LanguageModule } from '@language';
import { ShNotificationComponent } from '@stylehaven/components';
import { ErrorPageTemplate } from './error-page.template';
import { ErrorPageContainerComponent } from './error-page.container.component';

@Component({
    standalone: true,
    imports: [ShNotificationComponent, LanguageModule],
    selector: 'med-share-item-removed-container',
    template: ErrorPageTemplate,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShareItemRemovedContainerComponent extends ErrorPageContainerComponent {
    protected title: string = 'components.share-item-deleted.title';
    protected message: string = 'components.share-item-deleted.message';
}
